const isMobileWidth = () =>
  window.matchMedia('only screen and (max-device-width: 667px), screen and (max-width: 599px)').matches > 0;
export default isMobileWidth;
